import React, { useEffect } from 'react';
import { Navigate, useLocation, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const LanguageRouter = ({ children }) => {
  const { i18n } = useTranslation();
  const location = useLocation();
  const navigate = useNavigate();
  
  // Extract language from path
  const pathSegments = location.pathname.split('/').filter(Boolean);
  const currentLang = pathSegments[0];
  const isValidLang = ['ar', 'en'].includes(currentLang);
  
  // Get path without language prefix
  const pathWithoutLang = isValidLang 
    ? '/' + pathSegments.slice(1).join('/')
    : location.pathname;

  useEffect(() => {
    // Handle language changes
    if (isValidLang) {
      if (i18n.language !== currentLang) {
        i18n.changeLanguage(currentLang);
      }
      
      // Apply RTL/LTR styling
      if (currentLang === "ar") {
        document.body.classList.add("ar");
        document.dir = "rtl";
      } else {
        document.body.classList.remove("ar");
        document.dir = "ltr";
      }
    }
  }, [currentLang, i18n]);

  // Handle language switch
  const switchLanguage = (newLang) => {
    const newPath = `/${newLang}${pathWithoutLang}`;
    navigate(newPath, { replace: true });
  };

  // Redirect if no valid language prefix
  if (!isValidLang) {
    const defaultLang = i18n.language || 'ar';
    const newPath = `/${defaultLang}${pathWithoutLang}`;
    return <Navigate to={newPath} replace />;
  }

  return (
    <div className={`app-wrapper ${currentLang}`}>
      {React.Children.map(children, child =>
        React.cloneElement(child, { switchLanguage })
      )}
    </div>
  );
};

export default LanguageRouter;